import { useState } from "react"
import DeviceScreenLayout from "../../components/layouts/DeviceScreenLayout"
import Header from "../../components/layouts/Header"
import Button from "../../components/ui/Button"
import { LAYOUT } from "../../constants/layout"
import { requestPortonePayment } from "../../lib/portone"




const KeyPad = () => {

    const PadItem = ({item}) => {
        const [isPressed, setIsPressed] = useState(false);

        

        // 누르는 순간 활성화
        const handlePress = () => setIsPressed(true);
        // 손을 떼거나 영역을 벗어나면 비활성화
        const handleRelease = () => {
            setIsPressed(false);
            // if (onClick) onClick(item);
        };

        return (
            <div
                onMouseDown={handlePress}
                onMouseUp={handleRelease}
                onMouseLeave={() => setIsPressed(false)} // 밖으로 드래그하면 취소
                onTouchStart={handlePress} // 모바일/단말기 대응
                onTouchEnd={handleRelease}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '140px',
                    cursor: 'pointer',
                    userSelect: 'none', // 텍스트 선택 방지
                }}
            >
                <div
                    style={{
                        width: '72px', // 크기를 조금 더 키워 터치감을 높였습니다
                        height: '72px',
                        // 핵심 로직: 눌렸을 때만 배경색이 보이고, 아닐 땐 투명하게
                        background: isPressed ? 'rgba(0, 100, 255, 0.1)' : 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        // 부드러운 전환 효과
                        transition: 'background 0.2s ease',
                    }}
                >
                    <span
                        style={{
                            fontSize: '32px',
                            fontFamily: "Pretendard",
                            fontWeight: 500,
                            // 눌렸을 때 글자색도 살짝 진하게 변경 가능
                            color: isPressed ? '#212121' : '#525A65', 
                            transition: 'color 0.2s ease',
                        }}
                    >
                        {item}
                    </span>
                </div>
            </div>
        )
    }
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                // border: '1px solid #EFEFEF',
            }}
        >


            {["1", "2", "3", "4", "5", "6", "7", "8", "9", "00", "0", "←"].map((item) => {
                return (
                    <PadItem 
                        item={item}
                    />
                )

            })}

            
        </div>
    )
}



const PriceBadgeItem = ({price, unit}) => {
    return (
        <div
            style={{
                // border: '1px solid black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#F4F4F7',
                padding: '10px 14px',
                borderRadius: "20px",
                cursor: 'pointer'
            }}
        >
            <span
                style={{
                    fontSize: '20px',
                    fontFamily: "Pretendard",
                    fontWeight: 500,
                    // 눌렸을 때 글자색도 살짝 진하게 변경 가능
                    color: '#6E6F71',
                    transition: 'color 0.2s ease',
                    lineHeight: 1,
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                }}
            >
                {`${price.toLocaleString()}${unit}`}
            </span>

        </div>
    )
}

const PaymentsPage = () => {
    const [amount, setAmount] = useState(0)


    const handlePaymentClick = async (amount) => {
        try {
            // 1. 고유한 결제 ID 생성 (중복되면 결제창이 안 뜹니다)
            const paymentId = `payment-${crypto.randomUUID()}`;
    
            console.log("🚀 결제 요청 시작:", paymentId);
    
            // 2. 포트원 SDK 호출
            const response = await requestPortonePayment({
                paymentId: paymentId,
                orderName: "테스트 주문A",
                amount: amount,
            });
    
            // 3. 응답 처리
            if (response.code != null) {
                // 결제 실패 또는 취소
                // return alert(`결제 실패: ${response.message}`);

                return
            }
    
            // 4. 결제 성공 시 서버로 결제 정보 전달 (백엔드 검증 필수!)
            // const validation = await axios.post('/api/payments/complete', { paymentId: response.paymentId });

            
    
            
            
            alert("✅ 결제가 완료되었습니다!");
            console.log("결제 결과 정보:", response);
    
        } catch (error) {
            console.error("결제 중 오류 발생:", error);

            alert("결제 프로세스 중 에러가 발생했습니다.");
            alert(error)
        }
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;
        
        // 1. 숫자와 콤마를 제외한 모든 문자 제거, 콤마도 일단 제거해서 순수 숫자열만 만듦
        const onlyNumbers = inputValue.replace(/[^0-9]/g, "");
        
        // 2. 상태에는 콤마가 없는 "순수 숫자 문자열"만 저장
        setAmount(onlyNumbers);
    };


    return (
        <DeviceScreenLayout>
            
            <>
                <div
                    style={{
                        position: 'absolute',
                        // border: '1px solid green',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                        zIndex: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        justifyContent: 'center',
                        // border: '1px solid green',
                    
                    }}
                
                >
                    {/* 헤더 영역 */}
                    <Header 
                        isBackEnabled={true}
                    />
                    <div
                        style={{
                            flex: 1,
                            background: '#FFFFFF',
                            width: '100%',
                            display: 'flex',
                            padding: '24px',
                            // overflowY: 'scroll'
                            // background: 'blue',
                            gap: '72px',
                          
                        }}
                    >
                        <div
                            style={{
                                flex: 2.5,
                                // border: '1px solid red',
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '24px',
                                boxSizing: 'border-box',
                                minWidth: 0, 
                                minHeight: 0,
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '20px',
                                    fontFamily: "Pretendard",
                                    fontWeight: 500,
                                    // 눌렸을 때 글자색도 살짝 진하게 변경 가능
                                    color: '#6A6B6E',
                                    transition: 'color 0.2s ease',
                                }}
                            >
                                총 결제금액
                            </span>

                            <span
                                style={{
                                    fontSize: '32px',
                                    fontFamily: "Pretendard",
                                    fontWeight: 500,
                                    // 눌렸을 때 글자색도 살짝 진하게 변경 가능
                                    color: '#3F434A',
                                    transition: 'color 0.2s ease',
                                    marginTop: '16px',
                                }}
                            >
                                결제할 금액을 입력하세요
                            </span>


                            <div
                                style={{
                                    marginTop: '72px',
                                    width: '100%',
                                    border: '2px solid #477FEE',
                                    padding: '22px 24px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <input
                                    type="text" // 숫자에 콤마를 찍어야 하므로 type="number"는 쓸 수 없습니다.
                                    value={String(amount || "").replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    onChange={handleChange}
                                    style={{
                                        fontSize: '20px',
                                        fontFamily: "Pretendard",
                                        fontWeight: 400,
                                        // 눌렸을 때 글자색도 살짝 진하게 변경 가능
                                        color: '#6A6B6E',
                                        transition: 'color 0.2s ease',
                                        lineHeight: 1,
                                        flex: 1,
                                        border: 'none',
                                        outline: 'none',
                                    }}
                                >
                               
                                </input>
                                <span
                                    style={{
                                        fontSize: '20px',
                                        fontFamily: "Pretendard",
                                        fontWeight: 500,
                                        // 눌렸을 때 글자색도 살짝 진하게 변경 가능
                                        color: '#5F6061',
                                        transition: 'color 0.2s ease',
                                        lineHeight: 1,
                                    }}
                                >
                                    원
                                </span>
                            </div>


                            <div
                                style={{
                                    marginTop: '32px',
                                    // border: '1px solid red',
                                    display: 'flex',
                                    gap: '20px',
                                    flexWrap: 'wrap',

                                }}
                            >
                                <PriceBadgeItem 
                                    price={3000}
                                    unit={"원"}
                                />
                                <PriceBadgeItem 
                                    price={5000}
                                    unit={"원"}
                                />
                                <PriceBadgeItem 
                                    price={10000}
                                    unit={"원"}
                                />

                                <PriceBadgeItem 
                                    price={12000}
                                    unit={"원"}
                                />

                                <PriceBadgeItem 
                                    price={15000}
                                    unit={"원"}
                                />

                                <PriceBadgeItem 
                                    price={20000}
                                    unit={"원"}
                                />

                                <PriceBadgeItem 
                                    price={30000}
                                    unit={"원"}
                                />

                                <PriceBadgeItem 
                                    price={50000}
                                    unit={"원"}
                                />
                            </div>

                        </div>

                        {/* 키패드 항목 */}
                        <div
                            style={{
                                flex: 2,
                            }}
                        >
                            <KeyPad />
                        </div>


                    </div>


                    <div
                        style={{
                            borderTop: '1px solid #E0E0E0',
                            height: '72px',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                            padding: `0px ${LAYOUT.SIDE_PADDING}px`,
                        }}
                    >
                        <Button
                            text={"결제하기"}
                            onClick={() => {
                                console.log(amount)
                                handlePaymentClick(amount)
                            }}
                        />

                        

                    </div>
                    
                </div>
            </>
        </DeviceScreenLayout>
    )
}

export default PaymentsPage